import React, { createContext, useContext, useEffect, useState } from 'react';
import Cookies from 'js-cookie';
import { toast } from 'react-hot-toast';
import { clearTokens } from '../controllers/AuthController';
import { getAllSetting } from '../controllers/SettingController';
import LogoImage from '../assets/images/logo.png';

const SettingContext = createContext();

export const useSetting = () => useContext(SettingContext);

export const SettingProvider = ({ children }) => {
    const [setting, setSetting] = useState({
        logo_url: LogoImage,
        title_id: 'Puskesmas',
        title_en: 'Health Center',
        created_by: '',
        created_at: '',
        updated_by: '',
        updated_at: '',
    });
    const [loading, setLoading] = useState(true);
    
    const updateSetting = (settingData) => {
        setSetting(settingData);
    };
    
    useEffect(() => {
        const refreshToken = Cookies.get('refresh');
        if (!refreshToken) {
            clearTokens();
            setLoading(false);
            return;
        };
        
        const fetchSettings = async () => {
            try {
                const result = await getAllSetting();
                setSetting(result);
            } catch (error) {
                if (!error.message.includes('role has been updated')) {
                    toast.error('Failed to fetch settings');
                };
            } finally {
                setLoading(false);
            };
        };
        
        fetchSettings();
    }, []);
    
    return (
        <SettingContext.Provider value={{ loading, setting, updateSetting }}>
            {children}
        </SettingContext.Provider>
    );
};
